var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPadlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.46,
    height: 20.613,
    viewBox: "0 0 15.46 20.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "padlock",
    d: "M16.527,7.73h-.644V5.153a5.153,5.153,0,1,0-10.307,0V7.73H4.932A1.935,1.935,0,0,0,3,9.662v9.018a1.935,1.935,0,0,0,1.932,1.932H16.527a1.935,1.935,0,0,0,1.932-1.932V9.662A1.935,1.935,0,0,0,16.527,7.73ZM7.294,5.153a3.436,3.436,0,0,1,6.871,0V7.73H7.294Zm4.294,9.209v1.957a.859.859,0,0,1-1.718,0V14.362a1.718,1.718,0,1,1,1.718,0Z",
    transform: "translate(-3)",
    fill: "#77838f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.0bc3e80eaeb1a5d3a3015560b9b02742.svg";
export { ForwardRef as ReactComponent };